import React from 'react';
import { Outlet } from 'react-router-dom';

import { useAppSelector } from '~/behaviors/redux';
import { mui } from '~/tools/mui';
import { uiSelectors } from '~/behaviors/selectors/ui.selectors';

export const Restoring = () => {
  const { isRestoring } = useAppSelector(uiSelectors.selectAccountUI()) satisfies { isRestoring: boolean };

  if (isRestoring) {
    return (
      <mui.Box
        sx={(theme) => ({
          height: '100dvh',
          width: '100dvw',
          background: theme.legacyPalette.darkBlue,
        })}
      >
        &nbsp;
      </mui.Box>
    );
  }

  return <Outlet />;
};
